<template>
	<div class="inquiry-block bg-color--light-grey special-form-pt">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center ">
					<img class="c-special-inquiry__image" :src="'/en/vdatastore/image?id=' + content.article_osnovna_slika_id + '&variation=original'" alt="">
					
					<h2 class="special-form-title">{{content.content_section_name}}</h2>


				</div>
			</div>
		</div>
		<div class="container">
			<form id="special-form" action="/en/xinquiry/specialform">
			<div class="row">
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__fields">
							<p class="c-special-inquiry__title c-inquiry__title">
								{{msg.reservation_choice}}
							</p>
							<div class="inquiry-form__opt">

								<label class="inquiry-form__label" v-for="(checkbox, i ) in offers" :key="i" for="choiceBox" >
									<!-- <input type="hidden" :name="" value="false" class="inquiry-form__input-check"> -->
									<input type="radio" id="choiceBox" name="choiceBox" v-model="offerCheckboxes[i]"  :value="checkbox" class="inquiry-form__input-check">
									{{ checkbox }}
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__content" v-html="content.article_abstract"></div>
					</div>
				</div>
			</div>
			<hr>
			<div class="row">
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__fields">
							<p class="c-special-inquiry__title c-inquiry__title">
								{{msg.select_dates}}
							</p>
							<div class="col-12 col-lg-6">
								<!-- insert datepicker -->
								<div class="inquiry-form__datepicker">
									<date-picker></date-picker>
									<input type="hidden" name="date_from" :value="dates[0]">
									<input type="hidden" name="date_to" :value="dates[1]">
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__content" v-html="content.article_body"></div>
					</div>
				</div>
			</div>
			<hr>
			<div class="row">
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry">
						<div class="c-special-inquiry__fields">
							<p class="c-special-inquiry__title c-inquiry__title">
								{{msg.form_personalinfo}}
							</p>
							<div class="row">
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="first_name" value="" class="inquiry-form__input-text" :placeholder="msg.first_name">
									</label>
								</div>
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="last_name" value="" class="inquiry-form__input-text" :placeholder="msg.last_name">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="mail" name="email" value="" class="inquiry-form__input-text" :placeholder="msg.email">
									</label>
								</div>
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="phone" value="" class="inquiry-form__input-text" :placeholder="msg.phone">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="passport" value="" class="inquiry-form__input-text" :placeholder="msg.passport_num">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<p class="inquiry-form__section-lebel ">{{msg.birth_date}}</p>
								</div>
								<div class="col-12 col-lg-2">
									<label class="inquiry-form__label">
										<input type="text" name="birth_day" value="" class="inquiry-form__input-text" :placeholder="msg.birth_day">
									</label>
								</div>
								<div class="col-12 col-lg-2">
									<label class="inquiry-form__label">
										<input type="text" name="birth_month" value="" class="inquiry-form__input-text" :placeholder="msg.birth_month">
									</label>
								</div>
								<div class="col-12 col-lg-2">
									<label class="inquiry-form__label">
										<input type="text" name="birth_year" value="" class="inquiry-form__input-text" :placeholder="msg.birth_year">
									</label>
								</div>
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="birth_place" value="" class="inquiry-form__input-text" :placeholder="msg.birth_place">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<label class="inquiry-form__label">
										<textarea name="accompanied_persons" rows="8" cols="80" :placeholder="msg.accompanied_persons" class="inquiry-form__input-textarea"></textarea>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__fields">
							<p class="c-special-inquiry__title c-inquiry__title">
								{{msg.special_requests}}
							</p>
							<div class="row">
								<div class="col-12">
									<p class="inquiry-form__section-lebel ">{{msg.special_requests_text}}</p>

									<label class="inquiry-form__label">
										<textarea name="special_request" rows="8" cols="80" :placeholder="msg.special_requests" class="inquiry-form__input-textarea"></textarea>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr v-if="content.custom_fields.sf_bottom_msg">
			<div class="row" v-if="content.custom_fields.sf_bottom_msg">
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__content" v-html="content.custom_fields.sf_bottom_msg">
							<!--<p class="c-special-inquiry__info-title">{{msg.special_form_payment}}</p>
							<p class="c-special-inquiry__info-paragraph">
								{{msg.special_form_payment_info}}
							</p>
							<p class="c-special-inquiry__info-title">{{msg.special_form_payment_cancel}}</p>
							<p class="c-special-inquiry__info-paragraph">
								<ul class="c-special-inquiry__info-list" v-html="msg.special_form_payment_policy">
								</ul>
							</p>
							<p class="c-special-inquiry__info-paragraph">
								{{msg.special_form_payment_policy_reservation}}
							</p>-->
						</div>
					</div>
				</div>
			</div>
			<hr>
			<div class="row">
				<!-- <div class="col-12">
					<div class="c-special-inquiry__guarantee-box">
						<div class="c-special-inquiry__guarantee-box-left">
							<p class="c-special-inquiry__guarantee-box-title">
								GUARANTEE POLICY
							</p>
							<p class="c-special-inquiry__guarantee-box-paragraph">
								The hotel requires full credit card details to guarantee the reservation. 
								<strong>No deposit is required.</strong>
							</p>
						</div>
						<div class="c-special-inquiry__guarantee-box-right">
							<p class="c-special-inquiry__guarantee-box-title">
								SECURITY
							</p>
							<p class="c-special-inquiry__guarantee-box-paragraph">
								Your credit card information is securely sent to us via secure SSH protocol and your credit card information is crypted and only can be seen by our personel.
							</p>
						</div>
					</div>
				</div> -->
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="c-special-inquiry c-inquiry ">
						<div class="c-special-inquiry__fields">
							<!-- <p class="c-special-inquiry__title c-inquiry__title">
								{{msg.cc_info}}
							</p>
							<div class="row">
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="cc_type" value="" class="inquiry-form__input-text" :placeholder="msg.cc_type">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="cc_number" value="" class="inquiry-form__input-text" :placeholder="msg.cc_number">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-4">
									<label class="inquiry-form__label">
										<input type="text" name="cvc_number" value="" class="inquiry-form__input-text" :placeholder="msg.cvc_number">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-4">
									<label class="inquiry-form__label">
										<input type="text" name="cc_valid" value="" class="inquiry-form__input-text" :placeholder="msg.cc_valid">
									</label>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-6">
									<label class="inquiry-form__label">
										<input type="text" name="cc_holder" value="" class="inquiry-form__input-text" :placeholder="msg.cc_holder">
									</label>
								</div>
							</div> -->
							<div class="row">
								<div class="col-12">
									<div class="inquiry-form__opt">
										<label class="inquiry-form__label">
											<input type="checkbox" name="gdpr_accept" value="true" class="inquiry-form__input-check">
											&nbsp; <span v-html="msg.form_gdpr"></span>
										</label>
									</div>
									<button type="submit" @click.prevent="submit()" name="" class="inquiry-form__input-submit btn btn-secondary">{{msg.contact_send}}</button>
								</div>
								
							</div>

							<div class="row">
								<div class="col-12">
									<div v-if="formSuccess" class="c-inquiry__notice">
										<p class="c-inquiry__notice-title">
											<strong>{{msg.form_success}}</strong>
										</p>
									</div>
									<div v-if="errorMsg" class="c-inquiry__notice c-inquiry__notice--red">
										<p class="c-inquiry__notice-title c-inquiry__notice-title--red">
											{{msg.form_error}}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</form>	
		</div>
	
	</div>
</template>

<script>
import { eventBus } from '../../main.js';
import { mapState } from "vuex";

export default {
	data () {
		return {
			dates: [],
			errorMsg: false,
			formSuccess: false,
			offerCheckboxes: [],
			offers: []
		}
	},
	props: {
		content: Object,
	},
	created () {
		//find custom field checkboxes
		this.customFieldCheckboxes();
		//datepicker dates
		eventBus.$on('date-changed', payload => {
			this.dates = payload;
		});
		// console.log("-----------------",this.content);
		// this.dates.push(new Date());
		// let today = new Date();
		// let tomorrow = new Date();
		// tomorrow.setDate(today.getDate()+1);
		// this.dates.push(tomorrow);
	},
	computed: {
		...mapState({
			msg: state => state.msg,
		}),
	},
	methods: {
		customFieldCheckboxes() {
			//find checkboxes by key name in custom fields array
			let checkboxKeys = Object.keys(this.content.custom_fields).filter((key) => {
				return key.match('sf_checkboxes_0_');
			});
			//
			checkboxKeys.forEach(item => {
				let checkbox = this.content.custom_fields[item];
				if (checkbox != "") {
					this.offers.push(checkbox);
				}
			});
		},
		submit() {
			//remove err classes if any
			$('.inquiry-form__input-text').removeClass('inquiry-form__input-text--error');
			this.formSuccess = false;
			this.errorMsg = false;
			const self = this;
			let formObject = document.querySelector('#special-form');
			//create FormData
			let formData = new FormData(formObject);

			axios.post('/en/xinquiry/specialform', 
				formData, 
			)
			.then(function (response) {
				// console.log(response);
				let responseData = response.data;

				if (responseData.success) {
					self.formSuccess = true;
					//reset form 
					$('input').val('');
					$('textarea').val('');
					$('input[type=checkbox]').prop('checked', false);

				} else {
					self.errorMsg = true;
					
					Object.keys(responseData.form_error).forEach(item => {
						if (responseData.form_error[item]) {
							$('input[name='+ item + ']').addClass('inquiry-form__input-text--error');

							//check if the datepicker has dates selected, if not add the error class
							if (item === 'date_to') {
								$('.el-date-editor').addClass('inquiry-form__input-text--error');
							}

						}
					});

				}

			})
			.catch(function (error) {
				console.log(error);
			});

		}
	}
}
</script>

<style>

</style>
